export class Authentication {
    isAdmin: boolean;
    isUser: boolean;
    isComercial: boolean
}
